import {
  HTTPResponseError,
  PassworMatchLoginError,
  WrongPasswordError,
} from 'utils/errors';
import { m8ErrorMessageMap } from 'services/production/utils/constants';

export const processChangePasswordResponse = async (response: Response) => {
  if (!response.ok) {
    if (response.status === 400) {
      const data = await response.json();

      if (
        data.message === m8ErrorMessageMap.PASSWOR_MUSTNT_BE_EQUAL_LOGIN ||
        data.message === m8ErrorMessageMap.PASSWOR_MUSTNT_BE_MATCH_LOGIN_PART
      ) {
        throw new PassworMatchLoginError();
      }

      if (data.message === m8ErrorMessageMap.PASSWORD_IS_WRONG) {
        throw new WrongPasswordError();
      }
    }
    throw new HTTPResponseError(response);
  }
};
